import { render } from "./AddGardenBlock.vue?vue&type=template&id=244fc08b"
import script from "./AddGardenBlock.vue?vue&type=script&lang=js"
export * from "./AddGardenBlock.vue?vue&type=script&lang=js"

import "./AddGardenBlock.vue?vue&type=style&index=0&id=244fc08b&lang=scss"

import exportComponent from "/home/ubuntu/jalizan/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__